export const DASHBOARD_REQUEST = "DASHBOARD_REQUEST";
export const DASHBOARD_SUCCESS = "DASHBOARD_SUCCESS";
export const DASHBOARD_FAIL = "DASHBOARD_FAIL";
export const DASHBOARD_CLEAR_ERRORS = "DASHBOARD_CLEAR_ERRORS";
